import * as React from "react";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import CircularProgressWithLabel from "./Progress";
import { UserContext } from "../app/App";
import { ListItemButton } from "@mui/material";
import { Box } from "@mui/system";
import PharmaciesListExaminer from "./ExaminerView";
import ConfigData from "../config/config.json";
import NightsStayIcon from "@mui/icons-material/NightsStay";

const webserver = ConfigData.WEBSERVER;

export default function FolderList(props) {
  const { user, setUser } = React.useContext(UserContext);
  const [rows, setRows] = React.useState([]);
  const [twoIsEmpty, setTwoIsEmpty] = React.useState(0);

  var sleepIcon;

  if (twoIsEmpty === 2) sleepIcon = <NightsStayIcon />;

  React.useEffect(() => {
    fetch(
      webserver.protocol +
        "://" +
        webserver.host +
        ":" +
        webserver.port +
        "/examProcess/getAllForExaminer/" +
        user.name,
      { method: "GET", credentials: "include" }
    )
      .then((response) => {
        if (response.status !== 200) {
          throw new Error("Error: " + response.status);
        }
        return response;
      })
      .then((response) => response.json())
      .then((data) => {
        if (data.length === 1) {
          props.setSelectedProcess(data[0].id);
        }

        for (var i = 0; i < data.length; i++) {
          let examiners = "";

          for (var j = 0; j < data[i].examiners.length; j++) {
            examiners = examiners + data[i].examiners[j].username;
            if (j < data[i].examiners.length - 1) {
              examiners += ", ";
            }
          }
          data[i].examinersString = examiners;
        }

        setRows(data);
        if (data.length === 0) setTwoIsEmpty(2);
      })
      .catch((error) => {
        //TODO global error
      });
  }, []);

  return (
    <Box sx={{ display: "flex" }}>
      {twoIsEmpty === 2 ? "Derzeit keine Prüfungen" : ""}{" "}
      <span>&nbsp;&nbsp;</span> {sleepIcon}
      <List sx={{ width: "100%", maxWidth: 450, bgcolor: "background.paper" }}>
        {rows.map((row, index) => {
          let amountExamined = 0;

          for (
            let resultIndex = 0;
            resultIndex < row.results.length;
            resultIndex++
          ) {
            if (row.results[resultIndex].examinationDate !== null) {
              amountExamined++;
            }
          }

          return (
            <ListItem key={row.id}>
              <ListItemButton
                selected={props.selectedProcess === row.id}
                onClick={() => props.setSelectedProcess(row.id)}
              >
                <ListItemAvatar>
                  <CircularProgressWithLabel
                    value={(amountExamined / row.pharmacies.length) * 100}
                  />
                </ListItemAvatar>
                <ListItemText
                  primary={
                    amountExamined +
                    " / " +
                    row.pharmacies.length +
                    ", Geplantes Enddatum: " +
                    row.closingDateString
                  }
                  secondary={"Beteiligte Prüfer: " + row.examinersString}
                />
              </ListItemButton>
            </ListItem>
          );
        })}
      </List>
      {props.selectedProcess !== -1 ? (
        <PharmaciesListExaminer
          selectedProcess={props.selectedProcess}
          setSelectedProcess={props.setSelectedProcess}
          setRows={setRows}
        />
      ) : null}
    </Box>
  );
}
